import {useQuery} from "react-query";
import {UserService} from "./user.service";

export const useFetchUserScope = () => useQuery("userScope", () => UserService.fetchUserScope(false), {staleTime: Infinity})
export const useFetchUserFullScope = () => useQuery("userFullScope", () => UserService.fetchUserFullScope(), {staleTime: Infinity})
